<template>
  <el-row class="fullheight-nav">
    <el-col class="fullheight-nav" :span="24">
      <el-menu
        class="el-menu-vertical-demo fullheight-nav"
        :default-openeds="defaultOpenedsSubMenu"
        :default-active="defaultActiveMenuItem"
      >
        <el-popover placement="top-start" width="200" trigger="hover" content="这是一个防止bug的物件">
          <div :style="{height: 0}" slot="reference"></div>
        </el-popover>
        <el-tooltip effect="dark" :content="globalConfig.appName" placement="bottom">
          <el-menu-item index="0" @click="routeChange('/')">
            <h2 class="appname">{{globalConfig.appName}}</h2>
          </el-menu-item>
        </el-tooltip>

        <div v-for="item in menuData" :key="`submenu${item.index}`">
          <el-submenu v-if="'data' in item" :index="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <div v-for="link in item.data" :key="link.index">
              <el-menu-item
                v-if="link.show"
                :index="link.index"
                @click="routeChange(link.path)"
              >{{ link.content }}</el-menu-item>
            </div>
          </el-submenu>
          <el-menu-item
            v-if="'path' in item && item.show"
            :index="item.index"
            @click="routeChange(item.path)"
          >
            <i :class="item.icon"></i>
            {{item.content}}
          </el-menu-item>
        </div>

        <el-menu-item v-if="userInfo.user.is_admin" index="7" @click="routeChange('/admin')">
          <i class="el-icon-setting"></i>
          <span slot="title">管理面板</span>
        </el-menu-item>
        <el-menu-item
          v-if="userInfo.can_backtoadmin"
          index="8"
          @click="routeChange('/user/backtoadmin')"
        >
          <i class="el-icon-setting"></i>
          <span slot="title">返回管理员身份</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import PublicFunction from "../mixins/publicfunction";

export default {
  props: [
    "globalConfig",
    "userInfo",
    "defaultOpenedsSubMenu",
    "defaultActiveMenuItem"
  ],
  mixins: [PublicFunction],
  computed: {
    menuData() {
      return [
        {
          index: "1",
          content: "首页",
          icon: "el-icon-s-home",
          path: "/user",
          show: true
        },
        {
          index: "2",
          title: "我的账户",
          icon: "el-icon-user",
          data: [
            {
              index: "2-1",
              content: "设置",
              path: "/user/profile",
              show: true
            },
            {
              index: "2-2",
              content: "钱包",
              path: "/user/code",
              show: true
            },
            {
              index: "2-3",
              content: "推荐返利",
              path: "/user/invite",
              show: true
            },
          ]
        },
        {
          index: "3",
          content: "商店",
          path: "/user/shop",
          icon: "el-icon-shopping-cart-1",
          show: true
        },
        {
          index: "4",
          content: "节点列表",
          path: "/user/node",
          icon: "el-icon-s-promotion",
          show: true
        },
        {
          index: "5",
          content: "使用教程",
          path: this.tutorialPath,
          show: true,
          icon: "el-icon-bangzhu"
        },
      ];
    },
    isTicketShow() {
      return this.globalConfig.enable_ticket;
    },
    tutorialPath() {
      let result;
      if (this.globalConfig.next_config.custom_tutorial.value) {
        result = "/wiki";
      } else {
        result = "user/tutorial";
      }
      return result;
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.fullheight-nav
  height: 100%
.appname
  width: 100%
  text-align: center
  margin: 0
  overflow: hidden
  text-overflow: ellipsis
</style>
